// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed7485ff","455":"ecbe7276","635":"8b9d7cd3","640":"ffd63969"}[chunkId] + ".chunk.js";
};